import React from 'react';
import PropTypes from 'prop-types';

import { DatePicker, Input } from 'components/ui';

import * as Styled from './General.styles';

export const General = ({ form, isAdvancedView }) => {
  const { values, setFieldValue, errors } = form;

  return (
    <Styled.Wrapper>
      <Styled.FullNumberWrapper>
        <Input
          onChange={(value) => setFieldValue('fullNumber', value)}
          value={values.fullNumber}
          label="Numer dokumentu"
          error={errors.fullNumber}
        />
      </Styled.FullNumberWrapper>

      <Styled.DatesWrapper>
        <DatePicker
          onChange={(date) => setFieldValue('dateOfIssueUtc', date)}
          label="Data wystawienia"
          value={values.dateOfIssueUtc}
          error={errors.dateOfIssueUtc}
        />

        {isAdvancedView && (
          <DatePicker
            onChange={(date) => setFieldValue('dateOfSaleUtc', date)}
            label="Data sprzedaży"
            value={values.dateOfSaleUtc}
            error={errors.dateOfSaleUtc}
          />
        )}
      </Styled.DatesWrapper>
    </Styled.Wrapper>
  );
};

General.propTypes = {
  form: PropTypes.object.isRequired,
  isAdvancedView: PropTypes.bool,
};
